export function tem (item, lista = []) {
  return lista.indexOf(item) !== -1
}

export function naoTem (item, lista = []) {
  return lista.indexOf(item) === -1
}
